var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$apollo.loading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):_c('div',[(_vm.weightChart())?_c('highcharts',{attrs:{"options":_vm.weightChart()}}):_c('j-dotted-btn',{attrs:{"wide":"","color":"primary","to":"/checkins/new"}},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }